import React, { useCallback, useEffect, useState } from 'react';
import FloatingLabelInput from '../../../../components/floatingLabelInput';
import { formatDollarWithComma, formatPhoneNumber, validateField, dateStringInDays, isDateBefore } from '../../../../features/utils';
import FloatingLabelDate from '../../../../components/floatingLabelDate';
import FloatingLabelSelect from '../../../../components/floatingLabelSelect';
import { formatDate } from '../../../utils/formatDate';
import { useDispatch } from 'react-redux';
import { generateLink } from '../../../adminSlice';
import { ADMIN_LINK_GENERATION_FORM_DROPDOWN_API_URL, BACKEND_API_URL } from '../../../../config';
import Loader from '../../../../components/loader';
import LocationOption from './locationOptions';
import PLParticipation from './plParticipation';
import ManagerInfo from './managerInfo';
import CoManagerSection from './coManagerInfo';
// import BranchTypeSection from './branchTypeSection';
// import MarginManagement from './marginManagement';
import ManagerInfoModal from './mangerInfoModal';
import CoManagerInfoModal from './coManagerInfoModal';
import MarginManagementModal from './marginManagementModal';
import LocationDetailModal from './locationDetailModal';
import FormalDbaQuestion from './formalDbaQuestion';
import { NEW_RIZE_FOR_REALTOR_TEAM, isRizeForRealtorFlow, flowTypeLabel, rizeManagerDefaults, withoutAssignedLoanOfficers } from '../../../../config/flows';
import { showValidationError } from '../../../components/onboarding/apiHelper';


/** The flows that ask for a city / state — New Division and New Region do not. */
const hasLocationSection = (type) => type === 'New Satellite' || type === 'New Branch' || isRizeForRealtorFlow(type);

/** Only these flows show the Branch dropdown, so only these carry a branch. */
const hasBranchSelect = (type) => type === 'New Satellite' || isRizeForRealtorFlow(type);

/**
 * The dropdown API and the values saved on a link do not always agree on casing,
 * so every division / region / branch lookup compares trimmed, lower-cased copies.
 */
const sameOption = (a, b) =>
    String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

/** The link must expire in the future, so tomorrow is the earliest date allowed. */
const minExpiryDate = () => dateStringInDays(1);

/**
 * The link API rejects with its summary on the first line and one field error per
 * line after it — show the summary as the heading and the rest as a bullet list.
 */
const showLinkApiError = (error) => {
    const [summary, ...details] = String(error).split('\n');
    showValidationError(summary, details, { toastId: 'generate-link-error' });
};


function GenerateLink({ switchToMyLinks }) {
    const dispatch = useDispatch();
    const [data, setData] = useState({
        '_type': 'New Satellite',
        'division': '',
        'region': '',
        'branch': '',
        'recipientName': '',
        'recipientEmail': '',
        'recipientPhone': '',
        'expiryDate': formatDate(new Date(new Date().setDate(new Date().getDate() + 30))), // get 30 days
        'locationOption': '',
        'locationDetail': {},
        'pl': '',
        'isDBA': '',
        'coManagerExist': false,
        'ownMargin': '',
        // 'branchType': '',
        'mainBranch': {},
        'manager': {},
        'co_managers': [],
        'margin_management': [
            { name: 'FHA', margin: '', revenueCap: '', isRevenue: false },
            { name: 'FHA High Balance', margin: '', revenueCap: '', isRevenue: false },
            { name: 'FHA ARM', margin: '', revenueCap: '', isRevenue: false },
            { name: 'FHA Streamline', margin: '', revenueCap: '', isRevenue: false },
            { name: 'VA', margin: '', revenueCap: '', isRevenue: false },
            { name: 'VA High Balance', margin: '', revenueCap: '', isRevenue: false },
            { name: 'VA IRRL', margin: '', revenueCap: '', isRevenue: false },
            { name: 'USDA', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Conforming', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Conforming High Balance', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Conforming ARM', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Jumbo', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Jumbo ARM', margin: '', revenueCap: '', isRevenue: false },
            { name: 'Non-QM', margin: '', revenueCap: '', isRevenue: false },
        ]
    });

    const [divisions, setDivisions] = useState([]);
    const [regions, setRegions] = useState([]);
    const [branches, setBranches] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedRegion, setSelectedRegion] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
   
    // const [branchNames, setBranchNames] = useState([]);
    const [dropdownObject, setDropdownObject] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const [formErrors, setFromErrors] = useState({});
    const [isLocationDetailModalOpen, setIsLocationDetailModalOpen] = useState(false);
    const [isManagerModalOpen, setIsManagerModalOpen] = useState(false);
    const [isCoManagerExists, setCoManagerToggle] = useState(false);
    const [isCoManagerModalOpen, setIsCoManagerModalOpen] = useState(false);
    const [isOwnMarginSetupModalOpen, setisOwnMarginSetupModalOpen] = useState(false);
    const [coManagerEditIndex, setCoManagerEditIndex] = useState(null);
    const [onboardingForm, setOnboardingForm] = useState([])

    // Branch Names selection no longer needed on generateLink page
    // const fetchBranchNames = useCallback(async () => {
    //     try {
    //         setLoading(true);
    //         const response = await fetch(`${BRANCH_NAMES_API_URL}`, { method: 'POST' });
    //         if (response.ok) {
    //             const result = await response.json();
    //             setBranchNames(result?.ResultSets?.Table1.sort((a, b) => a.BranchNickname.localeCompare(b.BranchNickname)) || []);
    //         } else {
    //             console.error("Error fetching branch names");
    //         }
    //     } catch (error) {
    //         console.error(error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // }, []);


    const fetchFormDropDownData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetch(`${ADMIN_LINK_GENERATION_FORM_DROPDOWN_API_URL}`, {
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
            });
            
            if (response.ok) {
                const result = await response.json();
                // console.log("Dropdwon Object: ", result);
                
                setDropdownObject(result);
            } else {
                console.error("Error fetching form dropdown object");
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchOnboardingForm = useCallback(async () => {
        try {
            const response = await fetch(`${BACKEND_API_URL}/api/onboarding-form-data`);
            if (response.ok) {
                // The full list is kept here — each modal narrows it down, because a
                // Rize for Realtor team also uses a title without "Manager" / "Team Lead"
                // in its name (Business Development Specialist).
                const json_response = await response.json();
                setOnboardingForm(json_response)
            }
            else console.error("Error fetching onboarding form data");
        } catch (error) {
            console.error(error.message);
        }
    }, []);

    useEffect(() => {
        if (!onboardingForm.length) fetchOnboardingForm();
        if(!dropdownObject) fetchFormDropDownData();
        setDivisions(dropdownObject?.Divisions?.map(division => ({
            value: `${division.DivisionID} - ${division.DivisionName}`,
            label: `${division.DivisionID} - ${division.DivisionName}`,
          })))
    }, [onboardingForm, fetchOnboardingForm, dropdownObject, fetchFormDropDownData]);

    const handleIsCoManagerExists = () => {
        setCoManagerToggle(!isCoManagerExists);
        data.coManagerExist = !isCoManagerExists;
    }

    /** Matches a division by its "ID - Name" label, whatever the casing. */
    const findDivision = (divisionLabel) => (dropdownObject?.Divisions || []).find(
        division => sameOption(`${division.DivisionID} - ${division.DivisionName}`, divisionLabel)
    );

    const handleDivisionChange = (event) => {
        const selectedDivisionId = event.target.value;
        setSelectedDivision(selectedDivisionId);
        // console.log("selectedDivisionId: ", selectedDivisionId);

        if (selectedDivisionId) {
            const _selectedDivision = findDivision(selectedDivisionId);
            const newRegions = (_selectedDivision?.Regions || []).map(region => ({
            value: region.RegionName ? `${region.RegionID} - ${region.RegionName}` : region.RegionID,
            label:  region.RegionName ? `${region.RegionID} - ${region.RegionName}` : region.RegionID,
            }));
            // console.log("newRegions: ", newRegions);
            setRegions(newRegions);
        }
        else {
            setRegions([])
        }
        
        // Written as one update from the latest state — two separate setData calls
        // both read the same stale snapshot, so the second one undid the first and
        // the division / region / branch stored on the link came out empty.
        setData(prevData => ({ ...prevData, 'division': selectedDivisionId, 'region': '', 'branch': '' }));
        setSelectedRegion('');
        setSelectedBranch('');
        setBranches([]);
    };
    
      const handleRegionChange = (event) => {
        const selectedRegionId = event.target.value;
        setSelectedRegion(selectedRegionId);

        // console.log("selectedRegionId: ", selectedRegionId);
        if (selectedRegionId) {
            const _selectedDivision = findDivision(selectedDivision);

            const selectedRegion = (_selectedDivision?.Regions || []).find(region => {
                if (region.RegionName) return sameOption(`${region.RegionID} - ${region.RegionName}`, selectedRegionId);
                return sameOption(region.RegionID, selectedRegionId);
            });
            const newBranches = (selectedRegion?.Branches || []).map(branch => ({
            value: `${branch.BranchID} - ${ branch.BranchNickname}`,
            label: `${branch.BranchID} - ${ branch.BranchNickname}`
            }));
            setBranches(newBranches);
        }
        else {
            setBranches([])
        }
        
        
        // Region and branch move together, so they go in one update built from the
        // latest state — the old second setData dropped the region just selected.
        setData(prevData => ({ ...prevData, 'region': selectedRegionId, 'branch': '' }));
        setSelectedBranch(''); // Reset selected branch when region changes
      };

    const handleBranchChange = (e) => {
        const { value } = e.target;
        setSelectedBranch(value);
        setData(prevData => ({ ...prevData, 'branch': value }));
    }
     
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'expiryDate') {
            // A past date is refused outright rather than accepted and flagged: the
            // picker greys those days out via `min`, and a date typed in by hand is
            // dropped here, so the field can never end up holding one.
            if (isDateBefore(value, minExpiryDate())) {
                setFromErrors({
                    ...formErrors,
                    [name]: 'The Link Expiration Date must be a future date.',
                });
                return;
            }
            setData({ ...data, [name]: value });
            setFromErrors({ ...formErrors, [name]: '' });
        }
        else if (name === 'recipientPhone') {
            const formattedPhoneNumber = formatPhoneNumber(value);
            setData({...data, [name]: formattedPhoneNumber});
            setFromErrors({...formErrors, [name]: ''});
        }
        else {
            const validation = validateField(name, value);
            setData({ ...data, [name]: value });
            if (!validation) {
                setFromErrors({ ...formErrors, [name]: `Please enter a valid ${name}`})
            }
            else {
                setFromErrors({ ...formErrors, [name]: ``})
            }
        }
    }

    const handleMarginManagementChange = (index, type, value) => {
        // Update the state with the new value for the specified index and type
        let newValue = type === 'revenueCap' ? formatDollarWithComma(value) : value ;
        

        setData(prevState => {            
            // Copy the current margin_management array
            const updatedMarginManagement = prevState.margin_management.map((product, i) => {
                if (i === index) {
                    // Return a new product object with the updated value
                    return { ...product, [type]: newValue };
                }
                // Return the product unchanged if it's not the one being updated
                return product;
            });
    
            // Return the new state object with the updated margin_management array
            return {
                ...prevState,
                margin_management: updatedMarginManagement
            };
        });
      };


    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === 'recipientEmail') {
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setFromErrors({...formErrors, [name]: 'Please enter a valid recipient email address'});
            }
        }
        if (name === 'recipientPhone') {
            // Check if the number has 10 digits
            const rawNumbers = value.replace(/[^\d]/g, '');
            if (rawNumbers.length !== 10) {
                setFromErrors({...formErrors, [name]: 'Please enter a valid phone number'});
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        // A branch picked before the type was switched must not ride along on a flow
        // that has no Branch dropdown — it would be stored against the wrong region.
        const updatedData = {
            ...data,
            'division': selectedDivision,
            'region': selectedRegion,
            'branch': hasBranchSelect(data._type) ? selectedBranch : ''
          };

        const isFormValid = Object.values(formErrors).every((error) => error === '');
        const hasMarginFilled = updatedData.margin_management.some(item => item.margin === undefined || item.margin === '');
        const hasMarginIssue = updatedData.margin_management.some(item => item.isRevenue && (item.revenueCap === undefined || item.revenueCap === ''));
        

        if (isDateBefore(updatedData.expiryDate, minExpiryDate())) {
            showValidationError("Please choose a future date as the Link Expiration Date.")
        }
        else if (!isFormValid) {
            showValidationError("Please enter valid data in all the fields.")
        }
        // Only the flows that show the location section are asked for one — New
        // Division and New Region have no city/state field on this page.
        // The Branch column on My Links reads this value, so an empty one is caught
        // here as well — the dropdown's own `required` misses a stale selection.
        else if (hasBranchSelect(updatedData._type) && !String(updatedData.branch).trim()) {
            showValidationError("Please select a branch.")
        }
        else if (hasLocationSection(updatedData._type) && updatedData.locationOption === '') {
            showValidationError("Please select what city/state the branch/satellite will be located in.")
        }
        else if (hasLocationSection(updatedData._type) && Object.keys(updatedData.locationDetail).length === 0) {
            showValidationError("Please fill in the location details.")
        }
        else if (updatedData.pl === '') {
            showValidationError("Please answer whether the Branch will participate in the P and L.")
        }
        else if (updatedData.isDBA === '') {
            showValidationError("Please answer whether this opportunity will be a formal DBA.")
        }
        else if (Object.keys(updatedData.manager).length === 0) {
            showValidationError(isRizeForRealtorFlow(updatedData._type)
                ? "Please add Business Development Team Lead details."
                : "Please add manager details.")
        }
        else if (isCoManagerExists && updatedData.co_managers.length === 0) {
            showValidationError("Please add at least 1 co team lead.")
        }
        else if (updatedData.pl === 'No') {
            if (hasMarginFilled) {
                showValidationError('Please enter a valid margin value for all the products.');
            }
            else if (hasMarginIssue) {
                showValidationError('Please enter a valid revenue cap for the selected products.');
            }
            else {
                dispatch(generateLink(updatedData))
                    .unwrap()
                    .then(res => {
                        switchToMyLinks();  // Switch to "My Links" panel
                    })
                    .catch(err => {
                        console.error(err);
                        showLinkApiError(err);
                    })
            }
        }
        else {
            dispatch(generateLink(updatedData))
                .unwrap()
                .then(res => {
                    switchToMyLinks();  // Switch to "My Links" panel
                })
                .catch(err => {
                    console.error(err);
                    showLinkApiError(err);
                })
        }
    }

    const handleAddLocationDetail = (data) => {
        setData(prevData => ({
            ...prevData,
            locationDetail: {
                ...prevData.locationDetail,
                ...data
            }
        }));
    };

    const handleAddOrUpdateManagerInfo = (data) => {
        setData(prevData => ({
            ...prevData,
            manager: {
                ...prevData.manager,
                ...data
            }
        }));
    };

    const handleAddorUpdateCoManager = (coManagerData) => { 
        if (coManagerEditIndex !== null) {
            // Edit mode: update the specific co-manager
            setData(prevData => {
                const newCoManagers = [...prevData.co_managers];
                newCoManagers[coManagerEditIndex] = coManagerData;
                return { ...prevData, co_managers: newCoManagers };
            });
        } else {
            // Add mode: add a new co-manager
            setData(prevData => ({
                ...prevData, co_managers: [...prevData.co_managers, coManagerData]
            }));
        }
        setCoManagerEditIndex(null);
        setIsCoManagerModalOpen(false);
    }


    const handleCoManagerDelete = (index) => {        
        setData((prevData) => ({
            ...prevData,
            co_managers: prevData.co_managers.filter((_, i) => i !== index)
        }));
    }

    const handleCoManagerEdit = (index) => {
        setCoManagerEditIndex(index);
        setIsCoManagerModalOpen(true);
    }

    // Opening and closing the modal both clear the edit index — it used to survive a
    // cancelled edit, so the next "Add" reopened the record that was last edited.
    const handleCoManagerAdd = () => {
        setCoManagerEditIndex(null);
        setIsCoManagerModalOpen(true);
    }

    const handleCoManagerModalClose = () => {
        setCoManagerEditIndex(null);
        setIsCoManagerModalOpen(false);
    }

    const handleTypeRadio = (e) => {
        const _type = e.target.value;
        const isRize = isRizeForRealtorFlow(_type);
        // The Branch dropdown is hidden on the flows that do not use one, so the
        // branch selected earlier is dropped instead of being carried over unseen.
        if (!hasBranchSelect(_type)) setSelectedBranch('');
        setData(prevData => ({
            ...prevData,
            '_type': _type,
            'branch': hasBranchSelect(_type) ? prevData.branch : '',
            // A Rize for Realtor team never sets up its own margins
            'pl': isRize ? 'No' : prevData.pl,
            'ownMargin': isRize ? '' : prevData.ownMargin,
            // Manager details filled in for another flow stay in the form when the
            // type is switched — realign them with the Business Development Team Lead,
            // and drop the assigned Loan Officers when leaving this flow.
            'manager': isRize
                ? rizeManagerDefaults(prevData.manager)
                : withoutAssignedLoanOfficers(prevData.manager),
            'co_managers': isRize
                ? prevData.co_managers
                : prevData.co_managers.map(withoutAssignedLoanOfficers),
        }));
    }

    return (
        <div className="min-w-0 grow bg-[#f2ece9]">
        {loading && <Loader />}

        {/* Panel body */}
        <form onSubmit={handleSubmit} className="generate-link-form">
            <div className="mx-auto max-w-[1500px] space-y-5 p-4 sm:p-6 lg:p-8">
                <h2 className="text-2xl font-bold tracking-tight text-[#0a1445] sm:text-3xl">
                    Generate Link
                </h2>

                {/* Generate Link Form */}
                <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
                    <div className="text-sm text-slate-500">
                            Generate temporary links for the onboarding process.
                    </div>

                    <div>
                        {/* <h2 className="text-2xl text-[#0a1445] dark:text-slate-100 font-bold mb-6">Radio</h2> */}
                        <div className="link-type-options mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
                        <div className="m-3">
                            {/* Option */}
                            <label className="flex cursor-pointer items-center rounded-xl border border-slate-200 p-4 transition-all hover:border-orange-300 hover:bg-orange-50">
                                <input
                                type="radio"
                                name="radio-buttons"
                                className="form-radio w-4 h-4 text-custom-orange ring-custom-orange focus:ring-custom-orange"
                                value="New Division"
                                checked={data?._type === 'New Division'}
                                onChange={handleTypeRadio}
                                />
                                <span className="text-md ml-2">New Division</span>
                            </label>
                            </div>

                            <div className="m-3">
                            {/*  Option */}
                            <label className="flex cursor-pointer items-center rounded-xl border border-slate-200 p-4 transition-all hover:border-orange-300 hover:bg-orange-50">
                                <input
                                type="radio"
                                name="radio-buttons"
                                className="form-radio w-4 h-4 text-custom-orange focus:ring-custom-orange"
                                value="New Region"
                                checked={data?._type === 'New Region'}
                                onChange={handleTypeRadio}
                                />
                                <span className="text-md ml-2">New Region</span>
                            </label>
                            </div>

                            <div className="m-3">
                            {/* Option */}
                            <label className="flex cursor-pointer items-center rounded-xl border border-slate-200 p-4 transition-all hover:border-orange-300 hover:bg-orange-50">
                                <input
                                type="radio"
                                name="radio-buttons"
                                className="form-radio w-4 h-4 text-custom-orange  focus:ring-custom-orange" // Bigger radio button
                                value="New Branch"
                                checked={data?._type === 'New Branch'}
                                onChange={handleTypeRadio}
                                />
                                <span className="text-md ml-2">New Branch</span> {/* Bigger text */}
                            </label>
                            </div>

                            <div className="m-3">
                            {/* Option */}
                            <label className="flex cursor-pointer items-center rounded-xl border border-slate-200 p-4 transition-all hover:border-orange-300 hover:bg-orange-50">
                                <input
                                type="radio"
                                name="radio-buttons"
                                className="form-radio w-4 h-4 text-custom-orange  focus:ring-custom-orange" // Bigger radio button
                                value="New Satellite"
                                checked={data?._type === 'New Satellite'}
                                onChange={handleTypeRadio}
                                />
                                <span className="text-md ml-2">New Satellite / Team</span> {/* Bigger text */}
                            </label>
                            </div>

                            <div className="m-3">
                            {/* Option — Rize for Realtor (BDS) team */}
                            <label className="flex cursor-pointer items-center rounded-xl border border-slate-200 p-4 transition-all hover:border-orange-300 hover:bg-orange-50">
                                <input
                                type="radio"
                                name="radio-buttons"
                                className="form-radio w-4 h-4 text-custom-orange focus:ring-custom-orange"
                                value={NEW_RIZE_FOR_REALTOR_TEAM}
                                checked={isRizeForRealtorFlow(data?._type)}
                                onChange={handleTypeRadio}
                                />
                                <span className="text-md ml-2">New Rize for Realtor Team</span>
                            </label>
                            </div>
                        </div>
                    </div>

                    <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-10">
                        <div className="sm:w-1/2">
                            <FloatingLabelDate 
                                label="Link Expiration Date" 
                                handleChange={handleChange} 
                                value={data.expiryDate} 
                                name="expiryDate" 
                                id="expiryDate" 
                                required={true}
                                min={minExpiryDate()}
                            />
                        </div>
                        {data._type !== "New Division" && <div className="sm:w-1/2">
                            <FloatingLabelSelect
                                label="Division"
                                options={[{ value: '', label: 'Select Division' }, ...(divisions || [])]}
                                handleChange={handleDivisionChange}
                                value={selectedDivision}
                                name="division"
                                id="division"
                                required
                            />
                        </div>}
                    </div>
                    { (data._type !== "New Region" && data._type !== "New Division" ) && <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-6">
                        {(data._type === "New Satellite" || data._type === "New Branch" || isRizeForRealtorFlow(data._type)) && <div className="sm:w-1/2">
                            <FloatingLabelSelect
                                label="Region"
                                options={[{ value: '', label: 'Select Region' }, ...regions]}
                                handleChange={handleRegionChange}
                                value={selectedRegion}
                                name="region"
                                id="region-menu"
                                required
                            />
                        </div>}
                        {(data._type === "New Satellite" || isRizeForRealtorFlow(data._type)) && <div className="sm:w-1/2">
                            <FloatingLabelSelect
                                label="Branch"
                                options={[{ value: '', label: 'Select Branch' }, ...branches]}
                                handleChange={handleBranchChange}
                                value={selectedBranch}
                                name="branch"
                                id="branch-menu"
                                required
                            />
                        </div>}
                    </div>}
                    <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-6">
                        <div className="sm:w-1/2">
                            <FloatingLabelInput 
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={data.recipientName}
                                error={formErrors.recipientName}
                                name="recipientName" 
                                id="recipientName" 
                                label="Recipient's Name" 
                                required={true}
                            />
                        </div>
                        <div className="sm:w-1/2">
                            <FloatingLabelInput 
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={data.recipientEmail}
                                error={formErrors.recipientEmail}
                                name="recipientEmail" 
                                id="recipientEmail" 
                                label="Recipient's Email" 
                                type='email'
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-6">
                        <div className="sm:w-1/2">
                            <FloatingLabelInput 
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={data.recipientPhone}
                                error={formErrors.recipientPhone}
                                name="recipientPhone" 
                                id="recipientPhone" 
                                label="Recipient's Phone" 
                                type="tel"
                                required={true}
                            />
                        </div>
                    </div>
                </section>

                {/* Location Option — a Rize for Realtor team may have its own location */}
                <div className="grid gap-4 xl:grid-cols-2">
                {hasLocationSection(data?._type) && (
                    <LocationOption
                        data={data}
                        setData={setData}
                        organizationLevel={flowTypeLabel(data._type)}
                        isLocationDetailModalOpen={isLocationDetailModalOpen}
                        setIsLocationDetailModalOpen={setIsLocationDetailModalOpen}
                    />
                )}

                {/* P and L */}
                <PLParticipation
                    data={data}
                    setData={setData}
                    setisOwnMarginSetupModalOpen={setisOwnMarginSetupModalOpen}
                    locked={isRizeForRealtorFlow(data._type)}
                />

                {/* Formal DBA — asked here so the onboarding form only shows the DBA section when needed */}
                <FormalDbaQuestion
                    data={data}
                    setData={setData}
                />
                </div>

                {/* Add Manager / Business Development Team Lead Info */}
                <div className="grid gap-4 xl:grid-cols-2">
                <ManagerInfo
                    data={data}
                    setIsManagerModalOpen={setIsManagerModalOpen}
                    flowType={data._type}
                />

                {/* Assigned Loan Officers now live inside the Team Lead / Co Team Lead modals */}

                {/* Add Co Manager Info */}
                <CoManagerSection 
                    data={data} 
                    setIsCoManagerModalOpen={handleCoManagerAdd} 
                    handleEdit={handleCoManagerEdit}
                    handleDelete={handleCoManagerDelete}
                    handleIsCoManagerExists={handleIsCoManagerExists}
                    isCoManagerExists={isCoManagerExists}
                />
                </div>

                {/* Branch Type Selector */}
                {/* <BranchTypeSection 
                    data={data} 
                    setData={setData} 
                    branchNames={branchNames} 
                    fetchBranchNames={fetchBranchNames} 
                /> */}
                
                {/* Margin Management */}
                {/* <MarginManagement
                    data={data}
                    handleMarginManagementChange={handleMarginManagementChange}
                /> */}
            </div>

            {/* Panel footer */}
            <footer>
                <div className="mx-auto flex max-w-[1500px] justify-end px-4 pb-8 sm:px-6 lg:px-8">
                <div className="flex">
                    <button 
                        className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[#211b4f] px-6 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#30266c] focus:outline-none focus:ring-2 focus:ring-[#211b4f] focus:ring-offset-2"
                        type='submit'
                        >
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v14m0 0 4-4m-4 4-4-4M5 3h14" /></svg>
                        Generate Link
                    </button>
                </div>
                </div>
            </footer>
        
        </form>

        {isLocationDetailModalOpen &&
            <LocationDetailModal
                handleModalClose={() => setIsLocationDetailModalOpen(false)}
                organizationLevel={flowTypeLabel(data._type)}
                selectedOption={data.locationOption}
                onSave={handleAddLocationDetail}
                locationDetail={data.locationDetail}
            />
        }

        {/* Manager Info Modal */}
        <ManagerInfoModal
            isOpen={isManagerModalOpen}
            onboardingForm={onboardingForm}
            flowType={data._type}
            onSave={handleAddOrUpdateManagerInfo}
            handleModalClose={() => setIsManagerModalOpen(false)}
            managerData={  // auto populate with recipient data
                Object.keys(data.manager).length > 0 ? data.manager
                 : {
                    firstName: data.recipientName,
                    email: data.recipientEmail,
                    cellNumber: data.recipientPhone,
                 }
            } 

        />

        {/* Co Manager Info Modal */}
        <CoManagerInfoModal
            isOpen={isCoManagerModalOpen}
            onboardingForm={onboardingForm}
            onSave={handleAddorUpdateCoManager}
            handleModalClose={handleCoManagerModalClose}
            coManagerData={coManagerEditIndex !== null ? data.co_managers[coManagerEditIndex] : null}
            index={coManagerEditIndex}
            flowType={data._type}
        />

        {/* Margin Management Modal */}
        <MarginManagementModal
            isOpen={isOwnMarginSetupModalOpen}
            handleModalClose={() => setisOwnMarginSetupModalOpen(false)}
            handleMarginManagementChange={handleMarginManagementChange}
            data={data}
        />

        </div>
    );
}

export default GenerateLink;
